export const examplePrompts = {
  'Login Form': 'Create a login form with email and password fields, a "Remember me" checkbox, and a "Sign in" button',
  'Dashboard': 'Create a dashboard with a sidebar navigation, header with user avatar, and main content area with stats cards',
  'Pricing Table': 'Create a pricing table with 3 tiers (Basic, Pro, Enterprise) showing features and prices',
  'Contact Form': 'Create a contact form with name, email, message fields and a submit button',
  'Landing Page Hero': 'Create a hero section with a headline, subheadline, CTA button, and hero image placeholder',
  'Settings Page': 'Create a settings page with tabs for Profile, Notifications, and Privacy',
  'User Profile': 'Create a user profile page showing avatar, bio, stats, and recent activity',
  'Search Results': 'Create a search results page with filters sidebar and list of result cards'
}

export type ExamplePromptKey = keyof typeof examplePrompts
